package meineglasfaser.api

// See https://www.six-group.com/en/products-services/financial-information/market-reference-data/data-standards.html
// ISO 4217 (Currency Codes)
enum class Currency(
    val numericCode: Int,
    val minorUnit: Int?,
    val displayName: String,
    val displaySymbol: String,
) {
    EUR(
        numericCode = 978,
        minorUnit = 2,
        displayName = "Euro",
        displaySymbol = "€",
    ),
    USD(
        numericCode = 840,
        minorUnit = 2,
        displayName = "US Dollar",
        displaySymbol = "$",
    ),
    XTS(
        numericCode = 963,
        minorUnit = null,
        displayName = "TESTING",
        displaySymbol = "N.A.",
    ),
    XXX(
        numericCode = 999,
        minorUnit = null,
        displayName = "NO_CURRENCY",
        displaySymbol = "N.A.",
    );

    val alphabeticCode: String
        get() = name
}
